// src/components/UnderConstruction.jsx
import React from 'react';

const UnderConstruction = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#0097b2]-50 text-gray-800 px-4 text-center">
            <h1 className="text-4xl font-bold mb-4">🚧 Page Under Construction 🚧</h1>
            <p className="text-lg mb-3">This page will live soon.</p>
            <p className="text-md mb-2">
                For more details, you may contact at the mail:{" "}
                <a href="mailto:info@sssachievers.com" className="text-blue-600 underline">
                    info@sssachievers.com
                </a>
            </p>
        </div>
    );
};

export default UnderConstruction;
